import queryRightSidebar from './queryRightSidebar';

const SidebarLayout = ({ location }) => (queryRightSidebar());
export default SidebarLayout;
